import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserFeature } from '../../../../shared/models/feature.model';
import { PopupId } from '../../../../shared/models/popup.model';
import * as fromShared from '../../../../shared/store/selectors/shared.selector';
import { acknowledgePopupAction, goToAction } from '../../../../shared/store/actions/shared.action';

@Component({
  selector: `app-early-access-feature-dialog`,
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule],
  templateUrl: `./early-access-feature-dialog.component.html`,
  styleUrl: `./early-access-feature-dialog.component.scss`,
})
export class EarlyAccessFeatureDialogComponent implements OnInit {
  userFeature: UserFeature;
  popupId: PopupId;

  constructor(
    private readonly deviceDetectorService: DeviceDetectorService,
    private readonly sharedStore$: Store<fromShared.State>,
    private readonly dialogRef: MatDialogRef<EarlyAccessFeatureDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: { userFeature: UserFeature; popupId: PopupId },
  ) {}

  ngOnInit(): void {
    this.userFeature = this.data.userFeature;
    this.popupId = this.data.popupId;
  }

  closeDialog(): void {
    this.sharedStore$.dispatch(
      acknowledgePopupAction({
        popupId: this.popupId,
        acknowledgedFrom: this.deviceDetectorService.isDesktop() ? `DESKTOP` : `MOBILE`,
      }),
    );

    this.sharedStore$.dispatch(goToAction({ url: `/staking` }));

    this.dialogRef.close();
  }
}
